// assets
import {
  IconArrowMerge,
  IconBuilding,
  IconReportAnalytics,
  IconSchool,
  IconUserCheck,
  IconShieldLock,
  IconUsers
} from '@tabler/icons-react';

// types
import { NavItemType } from 'types';

// ==============================|| MENU ITEMS - IDENTITY (S-23) ||============================== //
// Tenant kullanıcı/rol yönetimi. API identity.users.read / identity.roles.read ister
// [STD-API-6]; izinsiz kullanıcıya ekran 403 ProblemDetails gösterir.

const identity: NavItemType = {
  id: 'identity',
  title: 'identity', // react-intl key (utils/locales/en.json) - i18n-ready [STD-DRIFT]
  icon: IconUsers,
  type: 'group',
  children: [
    {
      id: 'identity-users',
      title: 'identity-users',
      icon: IconUsers,
      type: 'item',
      url: '/identity/users',
      module: 'identity.users'
    },
    {
      // USER-REPORT: one person's orders, invoices, registrations, installments, exams and courses.
      // `module` — its own `identity.user_reports.menu` grant, as for every module.
      id: 'identity-user-reports',
      title: 'identity-user-reports',
      icon: IconReportAnalytics,
      type: 'item',
      url: '/identity/user-reports',
      module: 'identity.user_reports'
    },
    {
      // USER-MERGE (mig 643): the merge history. A special grant, so `permission`, not `module`.
      id: 'identity-user-merges',
      title: 'identity-user-merges',
      icon: IconArrowMerge,
      type: 'item',
      url: '/identity/users/merges',
      permission: 'identity.users.merge'
    },
    {
      id: 'identity-roles',
      title: 'identity-roles',
      icon: IconShieldLock,
      type: 'item',
      url: '/identity/roles',
      module: 'identity.roles'
    },
    {
      id: 'identity-companies',
      title: 'identity-companies',
      icon: IconBuilding,
      type: 'item',
      url: '/identity/companies',
      module: 'identity.companies'
    },
    {
      id: 'identity-schools',
      title: 'identity-schools',
      icon: IconSchool,
      type: 'item',
      url: '/identity/schools',
      module: 'identity.schools'
    },
    {
      // SCHOOL-MERGE (mig 760): the school-merge history. A special grant, so `permission`, not `module`.
      id: 'identity-school-merges',
      title: 'identity-school-merges',
      icon: IconArrowMerge,
      type: 'item',
      url: '/identity/schools/merges',
      permission: 'identity.schools.merge'
    },
    {
      // RSU: the partner-employee review queue. `module` (not `permission`) so a role granted ANY
      // action on identity.role_requests lights it up — the PA-7 module-derived visibility rule.
      id: 'identity-role-requests',
      title: 'identity-role-requests',
      icon: IconUserCheck,
      type: 'item',
      url: '/identity/role-requests',
      module: 'identity.role_requests'
    }
  ]
};

export default identity;
